export const PORTLAND_ORANGE = '#F46036';
export const DARK_LIVER = '#515052';
export const WELDON_BLUE = '#7A93AC';
export const BABY_POWDER = '#FFFFFA';
export const LICORICE = '#171219';
